import { AccomodationFirstChildren } from "@models/accomodation-first-children.model";
import CardInfoCard from "@components/CardInfo";
import { CardInfoTranslation } from "@models/card-info-translation.model";
import LogoComponent from "./LogoComponent";
import ContactButton from "./ContactButton";
import StaticCard from "./StaticCard";
import { GlobalContext } from "@utils/GlobalContext.js";
import { useContext } from "react";
import PhotoModals from "./PhotoModal";
import WhatsAndShareButtons from "./WhatsAndShareButtons";
import { CardInfoType } from "@enums/card-info-type.enum";
import { useLocation, useNavigate } from "react-router-dom";
import { t } from "i18next";
interface HomeAccomodationProps {
  accomodationAndChildren?: AccomodationFirstChildren;
}

export default function HomeAccomodation({ accomodationAndChildren }: HomeAccomodationProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { setSeeModal } = useContext(GlobalContext);
  if (!accomodationAndChildren) return null;
  const { accomodation, children, otherActiveAccomodation } = accomodationAndChildren;

  if (!accomodationAndChildren) {
    return null;
  }


  return (
    <div>
      <PhotoModals />
      <div className="position-relative header-home">
        <LogoComponent absolute={true} />
        <WhatsAndShareButtons title={accomodation?.accomodation?.name}/>
        {/* <div className="sponsored-icon-wrapper" onClick={() =>
          navigate(`${location.pathname}/Sponsored`)
        }>
          <img src="/images/hostyble_shop.png" alt="" className="banner-width" />
        </div> */}
        <div className="position-relative " style={{height:"100%"}}>
          <div className="hst-img-bg" role="button" onClick={() => setSeeModal(true)}></div>
          <picture>
            <source
              media="(min-width:1024px)"
              srcSet={`data:image/png;base64,${accomodation?.accomodation?.imgDesktop}`}
            />
            <source
              media="(min-width:650px)"
              srcSet={`data:image/png;base64,${accomodation?.accomodation?.imgMobile}`}
            />
            <img
              src={`data:image/png;base64,${accomodation?.accomodation?.imgMobile}`}
              alt="immagine"
              className="img-style b-block"
            />
          </picture>
          <i className="fa-solid fa-angle-left hst-carusel-arrow-left" role="button" onClick={() => setSeeModal(true)}></i>
          <i className="fa-solid fa-angle-right hst-carusel-arrow-right" role="button" onClick={() => setSeeModal(true)}></i>
        </div>
        <div className="dots" role="button" onClick={() => setSeeModal(true)}>
          <span className="dot active"></span>
          <span className="dot"></span>
          <span className="dot"></span>
        </div>
      </div>

      <div className="position-relative mt-4 mx-3 mb-5 mb-lg-0 d-flex flex-column justify-content-center align-items-center">

        <ContactButton />

        <div className="row row-cols-3 row-cols-md-4 row-cols-lg-5 g-4 mt-4  justify-content-center">

          {children?.filter(
            (el: CardInfoTranslation) => el.cardInfo?.displaySorting === 1
          )
            .map((el: CardInfoTranslation, i: number) => (
              <div key={i} className="col">
                <CardInfoCard data={el} />
              </div>
            ))}

          <StaticCard cardType="WhereWeAre" />
          <StaticCard cardType="Contact" />
          {/* <StaticCard cardType="Sponsored" /> */}

          {children
            ?.filter(el =>
              el.cardInfo?.displaySorting !== 1
            )
            .map((el: CardInfoTranslation, i: number) => (
              <div key={i} className="col">
                <CardInfoCard data={el} />
              </div>
            ))}
            <div className="col">
              <div
                role="button"
                className="d-flex flex-column justify-content-center align-items-center p-1 w-100"
                onClick={() =>navigate(`${location.pathname}/Sponsored`)}
              >
                <div className="card-info">
                  <img
                    src="/images/HostybleBAG.png"
                    alt="immagine"
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                      display: "block"
                    }}
                  />
                </div>
                <span className="title-card-info">
                  Shop
                </span>
              </div>
            </div>
            {otherActiveAccomodation !== 0 && otherActiveAccomodation != null ?
              (<div className="col">
                <div
                  role="button"
                  className="d-flex flex-column justify-content-center align-items-center p-1 w-100"
                  onClick={(e) => {
                    navigate(`${location.pathname}/Suggestion`)
                  }}
                >
                  <div className="card-info">
                    <img
                      src="/images/altre-proposte.jpg"
                      alt="immagine"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        objectPosition: "center",
                        display: "block"
                      }}
                    />
                  </div>
                  <span className="title-card-info">
                    {t("text.otherproposals")}
                  </span>
                </div>
              </div>
              ):(
                <></>
              )}
        </div>
      </div>
    </div>
  );
}